import { render } from "./TheHomePage.vue?vue&type=template&id=5ae2b519&scoped=true"
import script from "./TheHomePage.vue?vue&type=script&lang=js"
export * from "./TheHomePage.vue?vue&type=script&lang=js"

import "./TheHomePage.vue?vue&type=style&index=0&id=5ae2b519&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae2b519"]])

export default __exports__